import React, { useState, useEffect } from "react";
import { Line, Bar, Doughnut } from "react-chartjs-2";
import { labels, data, backgroundColor, borderColor } from "../../utils/const";

const Statistics = () => {
  const [chartData, setChartData] = useState({});
  // const [employeeSalary, setEmployeeSalary] = useState([]);
  // const [employeeAge, setEmployeeAge] = useState([]);

  const Chart = () => {
    setChartData({
      labels,
      datasets: [
        {
          label: ["Users"],
          data,
          backgroundColor,
          borderColor,
          borderWidth: 1,
          borderCapStyle: "butt",
          borderRadius: 6,
          fill: true,
        },
      ],
    });
  };

  useEffect(() => {
    Chart();
  }, []);

  return (
    <React.Fragment>
      <h3>Orders evolution chart</h3>
      <div>
        <Bar
          data={chartData}
          options={{
            responsive: true,
            title: { text: "Orders", display: true },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
          }}
        />
      </div>
      <br />
      <h3>Users evolution chart</h3>
      <div>
        <Line
          data={chartData}
          options={{
            responsive: true,
            title: { text: "Orders", display: true },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
          }}
        />
      </div>
      <br />
      <h3>Movies evolution chart</h3>
      <div>
        <Doughnut
          data={chartData}
          options={{
            responsive: true,
            title: { text: "Orders", display: true },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
          }}
        />
      </div>
    </React.Fragment>
  );
};

export default Statistics;
